import type { CATALOG_SORT_KEYS } from '~/utils/academy/constants';
export type AcademyTrainingsListingSortKey = (typeof CATALOG_SORT_KEYS)[number];
export type AcademyTrainingsListingSortDirection = 'asc' | 'desc';

export type AcademyTrainingsListingSort = {
    key: AcademyTrainingsListingSortKey;
    direction: AcademyTrainingsListingSortDirection;
};

/** The values of the `sort` URL parameter. One value for each option of the sort select. */
export enum AcademyTrainingsListingSortSlug {
    Newest = 'newest',
    Oldest = 'oldest',
    EventDate = 'event-date',
    NameAscending = 'name-asc',
    NameDescending = 'name-desc',
    MostPoints = 'most-points'
}
